import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../icon';
import colors from '../../../styles/constants.scss';
import { getClass } from '../../../utils/component-helpers';
import { STRATEGY_STATUSES } from '../../../utils/constants';

import './strategy-status.scss';

const labelAndImage = {
  expired: {
    icon: 'check',
    label: 'Completed',
    color: colors.grey33,
  },
  upcoming: {
    icon: 'dot',
    label: 'Upcoming',
    color: '#20B045',
  },
  running_and_paused: {
    icon: 'dot',
    label: 'Paused',
    color: colors.grey99,
  },
  running_and_active: {
    icon: 'live',
    label: 'Live',
    color: '#219653',
  },
};

const StrategyStatus = props => {
  const { iconOnly, status, enumKeys, styleType } = props;

  const statusKey = enumKeys ? STRATEGY_STATUSES[status] : status;

  if (!statusKey || !labelAndImage[statusKey]) {
    return null;
  }

  const { icon, label, color } = labelAndImage[statusKey];

  const iconSize = {
    text: 13,
    normal: 14,
    bold: 16,
  };

  return (
    <div className="strategy-status-badge">
      <Icon iconName={icon} color={color} size={iconSize[styleType]} />
      {!iconOnly && <span className={getClass('label', styleType)}>{label}</span>}
    </div>
  );
};

const statuses = Object.keys(labelAndImage);

StrategyStatus.propTypes = {
  status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconOnly: PropTypes.bool,
  enumKeys: PropTypes.bool,
  styleType: PropTypes.oneOf(['text', 'normal', 'bold']),
};

StrategyStatus.defaultProps = {
  status: null,
  iconOnly: false,
  enumKeys: false,
  styleType: 'bold',
};

export default StrategyStatus;
